<template lang="pug" src="./ClientProfile.pug"></template>
<script>

import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'
import router from '@/router'

  export default{
    props: ['clientItem'],

    methods: {
      ...mapGetters(['isTokenSet']),
    },
    //created () {
      //console.log(this.$route.params.id)
    //},
  }
</script>
